// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @actions
const cardsControlHistoryActions = require('actions/contactCenter/cardsControlHistory/cardsControlHistory');

// @ component
const CardsControlHistoryView = require('components/contactCenter/cardsControlHistoryView/cardsControlHistoryView');

class CardsControlHistoryViewContainer extends React.Component {
    render() {
        return (
            <CardsControlHistoryView {...this.props} />
        );
    }
}

CardsControlHistoryViewContainer.propTypes = {
    getQueryResults: PropTypes.func.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsControlHistory: PropTypes.object.isRequired,
    match: PropTypes.object,
    reset: PropTypes.func.isRequired,
    setDateFrom: PropTypes.func.isRequired,
    setDateTo: PropTypes.func.isRequired,
};

module.exports.constructor = CardsControlHistoryViewContainer;
module.exports.CardsControlHistoryViewContainer = connect(
    state => ({
        immCards: state.cards,
        immCardsControlHistory: state.cardsControlHistory
    }),
    {
        getQueryResults: cardsControlHistoryActions.getQueryResults,
        reset: cardsControlHistoryActions.reset,
        setDateFrom: cardsControlHistoryActions.setDateFrom,
        setDateTo: cardsControlHistoryActions.setDateTo,
    }
)(CardsControlHistoryViewContainer);
